/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calibration_Temperature_GoodInputs */



/**
* | output |
* | --- |
* | "Optimal time to recalibrate the room temperature" |
*
* @param {Calibration_Temperature_GoodInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const calibration_temperature_good = /** @type {((inputs?: Calibration_Temperature_GoodInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calibration_Temperature_GoodInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Optimal time to recalibrate the room temperature")
	return /** @type {LocalizedString} */ ("Moment optimal pour calibrer la température de la pièce")
});